export default __webpack_public_path__ + "images/47_1_image.jpg";